import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import HostQualityFiltersWrapper from './hostQuality/filters/HostQualityFiltersWrapper';
import ReviewsQuality from './hostQuality/ReviewsQuality';
import ListingQuality from './hostQuality/ListingQuality';
import { HostingQualityTitle } from './HostingQualityWrapper.styles';
import ReviewTags from './hostQuality/ReviewTags';
import HostQualityContextProvider from './HostQualityContextProvider';

const HostingQualityWrapper = () => {
  const { t } = useTranslation();

  return (
    <HostQualityContextProvider>
      <HostQualityFiltersWrapper />
      <HostingQualityTitle>
        {t('pageAnalytics.hostingQualityHeader')}
      </HostingQualityTitle>
      <Row>
        <ReviewsQuality />
        <ReviewTags />
      </Row>
      <Row>
        <ListingQuality />
      </Row>
    </HostQualityContextProvider>
  );
};

export default HostingQualityWrapper;
